import { Box, SimpleGrid, Text } from '@mantine/core';
import { InfoField } from '../../../../../ui/infoField/InfoField';
import useGetPlanDetails from '../../../../../../shared/hook/queries/useGetPlanDetails';

export default function PlanInfo(props: { planId: number }) {
  const { planId } = props;

  const { data } = useGetPlanDetails({ id: planId });

  return (
    <Box miw={400} maw={{ base: '100%', lg: '40%' }}>
      <Text fw={600} mb="xs">
        서비스 요금제 정보
      </Text>
      <Box
        style={{
          borderTop: '1px solid var(--mantine-color-gray-3)',
          borderLeft: '1px solid var(--mantine-color-gray-3)',
        }}
      >
        <SimpleGrid cols={2} spacing={0} verticalSpacing={0}>
          <InfoField label="서비스 요금제">{data?.planName || '서비스 없음'}</InfoField>
          <InfoField label="비고">
            <Text size="sm" lineClamp={3}>
              {data?.memo || ''}
            </Text>
          </InfoField>
        </SimpleGrid>
      </Box>
    </Box>
  );
}
